<template>
  <button
    type="button"
    class="selected-entity"
    title="Click to deselect the entity"
    @click="$emit('close')"
  >
    <div class="color-box" :style="{ background: color }"></div>
    <div class="title">{{ title }}</div>
    <font-awesome-icon icon="times" />
  </button>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    id: { required: true },
    color: { type: String, required: true }
  },
  event: "close"
};
</script>

<style lang="scss">
.selected-entity {
  padding: 0;
}

.selected-entity .color-box {
  width: 10px;
  height: 100%;
  margin-right: 5px;
  float: left;
}

.selected-entity .title {
  float: left;
  line-height: 20px;
  font-weight: bold;
}

.selected-entity svg {
  margin: 4px;
}
</style>
